// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const WarningOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m50.057 18.184 33.117 57.273c.906 1.566-.22 3.543-2.057 3.543H14.883c-1.837 0-2.963-1.977-2.057-3.543l33.117-57.273c.913-1.579 3.2-1.579 4.114 0Zm-7.577-2.002c2.454-4.243 8.586-4.243 11.04 0l33.117 57.273C89.09 77.697 86.023 83 81.117 83H14.883c-4.906 0-7.973-5.303-5.52-9.546L42.48 16.182ZM51.5 56a3 3 0 0 1-6 0V32a3 3 0 1 1 6 0v24Zm1 13a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
			fill="#fff"
		/>
	</svg>
);
export default WarningOutline;
